var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shop-page"},[_c('ShopHeader'),_c('Products')],1)}
var staticRenderFns = []

export { render, staticRenderFns }